import { EProductCode } from "@/types/enum";
// TODO: [match-phase] Restore `teal` import for MATCH badge color when match integration is implemented.
import { black, deepPurple, lightBlue /*, teal */ } from "@/theme/colors";
import { Box, Stack, styled, Tooltip } from "@mui/material";
import { FC } from "react";
import { EMPTY_STR } from "@/constants/string";

const SERVICE_COLORS: Record<string, { toolTipTittle: string; bg: string; text: string }> = {
  [EProductCode.VISA]: { toolTipTittle: "irohana visa", bg: lightBlue[100], text: black[30] },
  [EProductCode.ACCOUNT]: { toolTipTittle: "irohana account", bg: deepPurple[100], text: black[30] },
};

const DEFAULT_COLOR = { bg: deepPurple[100], text: black[30] };

export type TContractServiceBadgeItem = {
  code: string;
  /** 1文字表記 defined in masterData (master_products.single_char_label). */
  singleCharLabel?: string | null;
  /** Product name (from masterData when linked) — shown as the tooltip. */
  name?: string | null;
};

type Props = {
  products: TContractServiceBadgeItem[];
};

export const ContractServiceBadge: FC<Props> = ({ products }) => {
  const renderProduct = ({ code, singleCharLabel, name }: TContractServiceBadgeItem) => {
    const config = SERVICE_COLORS[code];
    const label = singleCharLabel || code?.charAt(0)?.toUpperCase() || EMPTY_STR.TEXT;
    const tooltip = name || config?.toolTipTittle || code || EMPTY_STR.TEXT;
    return (
      <Tooltip key={code} title={tooltip}>
        <Badge sx={{ backgroundColor: config?.bg ?? DEFAULT_COLOR.bg, color: config?.text ?? DEFAULT_COLOR.text }}>{label}</Badge>
      </Tooltip>
    );
  };

  return (
    <Stack direction="row" gap={0.5}>
      {products.map(renderProduct)}
    </Stack>
  );
};

const Badge = styled(Box)`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
`;
